<div class="cgs">
  <div class="gs">

    <!-- ============================================================ s1 : colonne gauche -->
    <div class="s1">

      <!-- b1 : nom et date de la liste -->
      <div class="bloc b1 ui-card" (click)="onEditList()">
        <div class="btneditevT"><span class="linepen"></span><i class="fad fa-pencil"></i></div>
        <div class="titev">{{ listName() }}</div>
        <div class="datev"><i class="fa-regular fa-calendar-clock"></i> &nbsp;<span class="respdis3"> Valide jusqu'au </span><span class="respvis3">Expire le </span>{{ listDateFmt().date }} <span class="respdis10">à </span><span class="respdis11">{{ listDateFmt().hour }}</span></div>
        <div class="adressev"><i class="fa-regular fa-arrow-right-to-arc"></i> &nbsp;{{ nbAccess() }} accès<span class="respdis30"> associé{{ nbAccess() > 1 ? 's' : '' }}</span><span class="respdis20"> à cette liste</span></div>
      </div>

      <!-- blocappa : terminaux de scan (statique) -->
      <div class="bloc blocappa ui-card">
        <div class="fdappa"></div>
        <div class="titappa">
          <i class="far fa-scanner-touchscreen"></i> &nbsp; Terminaux<span class="respdis8"> de scan</span>
          <div class="icinfoappa"><i class="fa-solid fa-info"></i></div>
        </div>
        <div class="textappa"></div>
        <a href="https://www.wilout.com/product/terminaux-wilout-control-pro" target="newBlank">
          <div class="btngoappa">Obtenir &nbsp; <i class="far fa-chevron-right" style="font-size:14px"></i></div>
        </a>
      </div>

      <!-- b3 : resume de la liste -->
      <div class="bloc b3 ui-card" [class.b3extand]="b3Expanded()">
        <div class="titshop">
          <i class="fa-duotone fa-light fa-clipboard-list-check icduotone"></i> &nbsp; Ma liste
          <div class="icmorelist" [class.icmoreliston]="b3Expanded()" (click)="toggleB3()">
            <div class="ml ml1"></div><div class="ml ml2"></div><div class="ml ml3"></div>
          </div>
        </div>
        <div class="mtnshop">
          <span id="mtntpltocheck">{{ tplCount() }}</span>&nbsp;<span class="txttbs">{{ tplCount() > 1 ? 'tarifs' : 'tarif' }}</span><span class="txttbs2"><span class="respdis16">, soit {{ toTickTxt() }} billet{{ toTick() > 1 ? 's' : '' }}</span></span>
        </div>
        <!-- Styles inline posés seulement après interaction (iso legacy) : en l'absence
             de toggle, le CSS (media queries incluses) garde la main. -->
        <div class="hlitb" [style.opacity]="b3Touched() ? (b3Expanded() ? '1.0' : '0.0') : null">Scan par tarif :</div>
        <div class="listplb"
             [style.height]="b3Touched() ? (b3Expanded() ? '155px' : '0px') : null"
             [style.margin-top]="b3Touched() ? (b3Expanded() ? '20px' : '0px') : null"
             [style.opacity]="b3Touched() ? (b3Expanded() ? '1.0' : '0.0') : null">
          @if (tplListbVisible().length === 0) {
            <div class="messlitb">Aucun tarif présent dans votre liste</div>
          } @else {
            @for (t of tplListbVisible(); track t.name) {
              <div class="litb">
                <div class="nameitb">{{ t.name }}</div>
                <div class="nbscanitb">{{ t.scanNbr }}</div>
              </div>
            }
            @if (tplListbHasMore()) {
              <div class="limoreitb" (click)="onConfigList()">Tout afficher</div>
            }
          }
        </div>
        <div class="btngoconflist" (click)="onConfigList()">
          Configurer &nbsp; <i class="far fa-chevron-right" style="font-size:14px"></i>
        </div>
      </div>

      <!-- info texte (masqué quand la liste des tarifs est dépliée, iso legacy) -->
      <div class="blocinfotext ui-card ui-card--outline"
           [style.height]="b3Touched() ? (b3Expanded() ? '0px' : '155px') : null"
           [style.margin-top]="b3Touched() ? (b3Expanded() ? '0px' : (wiw > 830 ? '20px' : '15px')) : null"
           [style.opacity]="b3Touched() ? (b3Expanded() ? '0.0' : '1.0') : null">
        <div class="titinfotext">
         <i class="fa-duotone fa-light fa-circle-info icduotone"></i> &nbsp; Informations
        </div>
        <div class="infotexttdb">
          &#9658; Cette page affiche uniquement les données des contrôles effectués avec la liste "<span class="namelist">{{ listName() }}</span>".
          <br>
          &#9658; Votre espace Wilout Control est automatiquement synchronisé avec votre
          <a href="https://wilout-online.com/#/login" target="blank" class="acwo">compte Wilout Online</a>.
        </div>
      </div>
    </div>

    <!-- ============================================================ s2 : timeline -->
    <div class="s2">
      <app-dashboard-timeline
        [minuteBuckets]="minuteBuckets()"
        [totalSTxt]="totalSTxt()"
        [totalInTxt]="totalInTxt()"
        [totalOutTxt]="totalOutTxt()"
        [totSPer]="totSPer()"
        [totInPer]="totInPer()"
        [totOutPer]="totOutPer()"
        [toScan]="toScan()"
        [toScanTxt]="toScanTxt()"
        [totIn]="totIn()"
        [totS]="totS()"
        [totOut]="totOut()"
        [cgs]="cgs()"
        [overmax]="overmax()"
        [recentS]="recentS()"
        [recentIn]="recentIn()"
        [recentOut]="recentOut()"
        (displayChange)="onTimelineDisplay($event)"
        (refresh)="onRefresh()">
      </app-dashboard-timeline>

      <!-- Tooltips de la timeline (positionnement global via JS du sous-composant) -->
      <div class="labG">
        <div id="mtnlabG">0</div>
        <div class="iclabG"><i class="fas fa-caret-down"></i></div>
      </div>
      <div class="dateG"></div>
    </div>

    <!-- ============================================================ s3 : stats / jauges -->
    <div class="s3">

      <!-- b2 : donut + totaux (mis a jour par la timeline) -->
      <div class="bloc b2 ui-card" (click)="toggleCgs()">
        <div class="recettestexte">
          <i class="fa-duotone fa-light fa-chart-pie icduotone"></i>
          &nbsp; <span class="titb2" [innerHTML]="b2Display().titb2"></span>
          <div class="contper">
            <div class="minper">
              <span class="mper" [innerHTML]="b2Display().mper"></span>
              @if (cgs() === 0) { <span class="sper">%</span> }
            </div>
            <!-- Petit anneau du badge % (position legacy : dans .contper) -->
            <app-dashboard-donuts variant="E" [donut]="donutSeries()"></app-dashboard-donuts>
          </div>
        </div>
        <div class="tot">
          <div class="mtntot" [innerHTML]="b2Display().mtntot"></div>
          <div class="texttotparT" [innerHTML]="b2Display().texttotparT"></div>
        </div>
        <!-- Grand anneau central (position legacy : enfant direct de .b2, après .tot) -->
        <app-dashboard-donuts variant="D" [donut]="donutSeries()"></app-dashboard-donuts>
      </div>

      <!-- Jauges par tarif -->
      <div class="bloctpltdb ui-card ui-card--hover"
           [class.blocopen]="activePanel() === 'tarif'"
           (click)="onSwitchToTarif()">
        <div class="titbloctpltdb">
          <i class="fa-duotone fa-light fa-ticket icduotone"></i> &nbsp; <span class="respdi12">Contrôles </span>par tarif
          <div class="icedittpltdb">
            <i class="fas fa-cog cog1"></i><i class="fas fa-cog cog2"></i>
          </div>
        </div>
        <div class="btnswitchtpl" (click)="$event.stopPropagation(); onSwitchToTarif()">Afficher</div>
        <div class="tritpltdb">
          <span class="respdis5" style="color:var(--ui-color-text-muted);">Trier par : &nbsp;</span>
          <span class="btntritpltdb" (click)="$event.stopPropagation(); toggleTarifSort()">proportion contrôlée &nbsp;<i class="fas" [class.fa-chevron-down]="tarifSortDir() === 'desc'" [class.fa-chevron-up]="tarifSortDir() === 'asc'"></i></span>
        </div>
        <div class="listtpltdb">
          <app-dashboard-scan-list [rows]="tarifsRows()" variant="tarif"></app-dashboard-scan-list>
        </div>
      </div>
      <div class="nbcpt" style="opacity:0"><div class="icnbcpt"><i class="fa-solid fa-caret-left"></i></div><span id="mtnnbcpt">0</span></div>

      <!-- Jauges par acces -->
      <div class="bloc blocaccestdb ui-card ui-card--hover"
           [class.blocopen]="activePanel() === 'access'"
           (click)="onSwitchToAccess()">
        <div class="titaccestdb">
          <i class="fa-duotone fa-light fa-right-to-bracket icduotone"></i> &nbsp; <span class="respdi12">Contrôles </span>par accès
          <div class="iceditaccestdb"><i class="fas fa-cog cog1"></i><i class="fas fa-cog cog2"></i></div>
        </div>
        <div class="btnswitchacs" (click)="$event.stopPropagation(); onSwitchToAccess()">Afficher</div>
        <div class="triacstdb">
          <span class="respdis5" style="color:var(--ui-color-text-muted);">Trier par : &nbsp;</span>
          <span class="btntriacstdb">nombre de contrôle &nbsp;<i class="fas fa-chevron-down"></i></span>
        </div>
        <div class="listacstdb">
          <app-dashboard-scan-list [rows]="accessRows()" variant="access"></app-dashboard-scan-list>
        </div>
      </div>
      <div class="nbcpa" style="opacity:0"><div class="icnbcpa"><i class="fa-solid fa-caret-left"></i></div><span id="mtnnbcpa">0</span></div>
    </div>
  </div>

  <!-- ============================================================ s4 : bas de page -->
  <div class="s4">
    <div class="inters4"></div>
    <div class="hs4">Guide d'utilisation :</div>

    <!-- Carousel -->
    <div class="blocbas">
      <app-dashboard-carousel [items]="carouselItems()"></app-dashboard-carousel>
    </div>

    <!-- Parrainage -->
    <div class="blocrist">
      <div class="sliderist">
        <div class="contrist1">
          <div class="titrist"><i class="far fa-badge-percent"></i> &nbsp;Parrainage</div>
          <div class="txtrist">
            Recommandez Wilout à votre entourage et bénéficiez de notre système d'affiliation.
            <div class="morerist">En savoir plus &nbsp;<i class="fas fa-chevron-right" style="font-size:11px"></i></div>
          </div>
        </div>
        <div class="contrist2">
          Pour profiter de notre système d'affiliation,<br>il vous suffit d'amener un contact à s'inscrire et à utiliser un des services Wilout. Contactez ensuite notre équipe commerciale pour valider le partenariat.
          <a href="mailto:support@wilout.com?subject=Programme de réduction"><div class="contactrist">Contacter</div></a>
          <div class="lessrist"><i class="fas fa-chevron-left" style="font-size:11px"></i>&nbsp; Retour</div>
        </div>
      </div>
    </div>

    <!-- b7 : etapes de configuration -->
    <div class="b7">
      <div class="titconf"><i class="far fa-wrench"></i> &nbsp;Étapes de configuration</div>
      <div class="textprogstep">
        <div style="float:left;">Progression : &nbsp;</div>
        <div style="float:left;font-weight:800;" class="mtprogstep">{{ progressPct() }}%</div>
        <div class="barprog ui-progress">
          <div class="prog ui-progress__bar" [style.width.%]="progressPct()"></div>
        </div>
      </div>
      <app-dashboard-steps [steps]="configSteps()"></app-dashboard-steps>
    </div>

    <!-- b8 : planning cashless -->
    <div class="b8">
      <div class="titast"><i class="far fa-calendar-check"></i> &nbsp;Planning du cashless</div>
      <div class="ast astg"><div class="casJt">J-20</div>Assurez-vous d'avoir commandé vos terminaux de contrôle au moins 3 semaines avant lancement.</div>
      <div class="ast"><div class="casJt">J-5</div>Configurez vos listes et vos accès. Vous pouvez vous aider en suivant les étapes présentées ci-dessus.</div>
      <div class="ast astg"><div class="casJt">J0</div>Gardez un oeil sur vos participants. Votre espace est compatible sur ordinateurs, tablettes et mobiles.</div>
      <div class="ast"><div class="casJt">J+2</div>Retournez-nous les terminaux en apposant sur la valise le bon de transport mis à votre disposition.</div>
      <div class="ast astg"><div class="casJt">J+3</div>Analysez toutes vos données pour optimiser la gestion des visiteurs sur vos prochains événements.</div>
    </div>

    <!-- b9 : aide et contacts -->
    <div class="b9">
      <div class="titcontact"><i class="far fa-user-headset"></i> &nbsp;Aide et contacts</div>
      <div class="btnhelpT" routerLink="/support"><i class="fas fa-envelope" style="font-size:13px"></i> &nbsp;Accéder à la page support</div>
      <div class="btnphoneT"><i class="fas fa-phone"></i> &nbsp;Contacter un de nos conseillers</div>
    </div>

    <!-- b10 : plus de services -->
    <div class="b10">
      <div class="titmore">
        <i class="far fa-plus-square" style="font-size:16px"></i> &nbsp;Plus de services
      </div>
      <a href="https://wilout.com/billetterie-en-ligne" target="blank"><div class="btnserv bs1" style="margin-left:20px"><i class="far fa-ticket-alt"></i></div></a>
      <a href="https://wilout.com/guichet-vente-de-billet" target="blank"><div class="btnserv bs2"><i class="far fa-print"></i></div></a>
      <div class="btnserv btnservon bs3"><i class="fa-solid fa-scanner-touchscreen"></i></div>
      <a href="https://wilout.com/paiement-cashless" target="blank"><div class="btnserv bs4"><i class="far fa-watch-fitness"></i></div></a>
    </div>
  </div>
</div>

<!-- Popin terminaux -->
<div class="fdpopedit"></div>
<div class="blocedit popinfoAppa ui-card">
  <div class="headedit"><i class="fad fa-scanner-touchscreen"></i> &nbsp;Terminaux de scan</div>
  <div class="bodinfoAppa">
    <span style="font-weight:800;font-size:17px">Optez pour la performance !</span>
    <br><br><br>
    Simples, rapides, mobiles, découvrez nos terminaux de contrôle dernière génération.
    <br><br>Contrôlez en un rien de temps des milliers d'entrées.
    <br>Vérifiez et validez facilement les billets de tous vos particpants grâce au lecteur laser intégré.
    <br><br>Nos terminaux fonctionnent avec ou sans connexion internet et sont tous dotés d'une batterie longue-durée.
    <br><br><br>
    <span style="font-weight:800">Disponible à la location, obtenez dès maintenant vos appareils Wilout Control.</span>
    <a href="https://www.wilout.com/product/terminaux-wilout-control-pro" target="newBlank" class="als">
      <div class="linktoshop">Commander &nbsp;<i class="far fa-chevron-right"></i></div>
    </a>
  </div>
</div>
<div class="blocedit popinfoTel ui-card">
  <div class="headedit"><i class="fad fa-phone"></i> &nbsp; Téléphone :</div>
  <div class="bodinfoTel">
    <span style="font-weight:800;font-size:18px">+ 33 (0)4 83 39 77 54</span>
    <br><br>Du lundi au vendredi de 9h00 à 18h00.
  </div>
</div>

<!-- Gradient SVG pour les donuts -->
<svg width="0" height="0">
  <defs>
    <linearGradient id="st4" x1="0%" y1="0%" x2="0%" y2="100%">
      <stop offset="0%"   style="stop-color: var(--primary)"/>
      <stop offset="100%" style="stop-color: var(--primary-light-a)"/>
    </linearGradient>
  </defs>
</svg>
